import classNames from 'classnames';

import { usePostContentContext } from '@/postContentElement/context';

import { embedTitleContainer, embedTitleParagraph } from './GenericEmbedTitle.css';
import type { TPostGenericEmbedTitleProps } from './GenericEmbedTitle.types';

export const PostGenericEmbedTitle = ({ element, children, editorMode }: TPostGenericEmbedTitleProps) => {
  const { postTheme } = usePostContentContext();
  const textContent = element?.content?.[0]?.text;
  const isHidden = postTheme?.hyperlink_hide_title === 'true';

  if (!editorMode && (!textContent || isHidden)) return null;

  return (
    <div data-generic-embed-title className={classNames(embedTitleContainer, editorMode && isHidden && 'hidden')}>
      <p className={embedTitleParagraph}>{editorMode ? children : textContent}</p>
    </div>
  );
};
